import { render, staticRenderFns } from "./UserTypeTextTemplate.vue?vue&type=template&id=804b6b8a&scoped=true&"
import script from "./UserTypeTextTemplate.vue?vue&type=script&lang=js&"
export * from "./UserTypeTextTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b6b8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
